import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Header from "../../components/Header.jsx";
import Footer from "../../components/Footer.jsx";
import "../../styles/pages/subpages/details_page.css";

import ChevronRightIcon from "../../assets/icons/chevron-right.svg";
import { fetchNewsById, fetchPromotionById } from "../../services/apiService";
import Loader from "../../components/Loader.jsx";
import ErrorPage from "../ErrorPage.jsx";
import { formatDate } from "../../utils/dateUtil";
import PlaceHolderImage from "../../assets/images/placeholder.png";

import { IMAGE_BASE_URL } from "../../services/imageConfig.js";

const DetailsPage = () => {
  const { state } = useLocation();
  const { id: paramId } = useParams();

  const initialId = state?.id || paramId;
  const initialType = state?.type;

  const [details, setDetails] = useState(null);
  const [error, setError] = useState(null);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const src = details?.titleImage
    ? IMAGE_BASE_URL + details.titleImage
    : PlaceHolderImage;

  useEffect(() => {
    const fetchData = async () => {
      if (!initialId || !initialType) {
        setError("Нет данных для запроса подробностей");
        return;
      }
      setIsDataLoading(true);
      try {
        let data;
        if (initialType === "news") {
          data = await fetchNewsById(initialId);
        } else if (initialType === "promotion") {
          data = await fetchPromotionById(initialId);
        }
        setDetails(data);
      } catch (err) {
        setError("Ошибка загрузки данных");
      } finally {
        setIsDataLoading(false);
      }
    };

    fetchData();
  }, [initialId, initialType]);

  useEffect(() => {
    if (details) {
      const imageUrls = [];
      if (details.titleImage) imageUrls.push(IMAGE_BASE_URL + details.titleImage);
      if (details.type === "news") {
        if (details.imageFirst) imageUrls.push(IMAGE_BASE_URL + details.imageFirst);
        if (details.imageSecond) imageUrls.push(IMAGE_BASE_URL + details.imageSecond);
      } else if (details.type === "promotion") {
        if (details.imageFirst) imageUrls.push(IMAGE_BASE_URL + details.imageFirst);
        if (details.imageSecond) imageUrls.push(IMAGE_BASE_URL + details.imageSecond);
      }

      if (imageUrls.length === 0) {
        setImagesLoaded(true);
      } else {
        Promise.all(
          imageUrls.map(
            (url) =>
              new Promise((resolve) => {
                const img = new Image();
                img.src = url;
                img.onload = resolve;
                img.onerror = resolve;
              })
          )
        ).then(() => {
          setImagesLoaded(true);
        });
      }
    }
  }, [details]);

  if (error) {
    return <ErrorPage />;
  }

  if (isDataLoading || !details || !imagesLoaded) {
    return (
      <div className="loader-wrapper">
        <Loader />
        <p className="loading-text">Загрузка...</p>
      </div>
    );
  }

  const renderContent = () => {
    if (details.type === "news") {
      return (
        <div className="content-block">
          {details.imageFirst && (
            <img
              src={IMAGE_BASE_URL + details.imageFirst}
              alt="news"
              className="content-image"
            />
          )}
          {(details.newsDetails || details.description) && (
            <p className="content-text">{details.newsDetails || details.description}</p>
          )}
          {details.imageSecond && (
            <img
              src={IMAGE_BASE_URL + details.imageSecond}
              alt="news"
              className="content-image"
            />
          )}
        </div>
      );
    }

    if (details.type === "promotion") {
      if (details.promotionStatus === false) {
        return (
          <div className="finished-promotion">
            <div className="winners-table-container">
              <table className="table">
                <colgroup className="table-colgroup">
                  <col className="table-col number" />
                  <col className="table-col spacer-col" />
                  <col className="table-col prize" />
                  <col className="table-col spacer-col" />
                  <col className="table-col serial-number" />
                  <col className="table-col spacer-col" />
                  <col className="table-col full-name" />
                </colgroup>
                <thead className="table-thead">
                  <tr className="table-header-row">
                    <th className="table-header winners-header">Номер</th>
                    <th className="table-header spacer"></th>
                    <th className="table-header winners-header">Приз</th>
                    <th className="table-header spacer"></th>
                    <th className="table-header winners-header">Серийный номер</th>
                    <th className="table-header spacer"></th>
                    <th className="table-header winners-header">Ф.И.О.</th>
                  </tr>
                </thead>
                <tbody>
                  {details.promotionWinners &&
                    details.promotionWinners.map((winner) => (
                      <tr key={winner.id} className="table-row">
                        <td className="table-cell">{winner.serialNumber}</td>
                        <td className="table-cell spacer"></td>
                        <td className="table-cell">{winner.nameOfThePrize}</td>
                        <td className="table-cell spacer"></td>
                        <td className="table-cell">{winner.serialNumber}</td>
                        <td className="table-cell spacer"></td>
                        <td className="table-cell">{winner.fullName}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="finished-promotion-text-block">
              <p className="finished-promotion-title">Спасибо, что вы с нами!</p>
              <p className="finished-promotion-text">
                Главным критерием является номер билета, в фамилиях могут быть неточности,
                т.к. в билет ФИО вписывались вручную. Для получения приза, Вам необходимо позвонить по номеру.
              </p>
              <div className="finished-promotion-contact">
                <span>996557294949</span>
                <span className="finished-promotion-contact-text">горячая линия</span>
              </div>
              <p className="finished-promotion-text">
                Также обращаем ваше внимание, что согласно законодательству КР,
                победитель должен уплатить 10% налог от стоимости приза.
                Призы выдаются в течение трех месяцев с даты розыгрыша.
              </p>
              <p className="finished-promotion-text">Спасибо за участие!</p>
              <p className="finished-promotion-text">
                Выигрыши по основному розыгрышу выдаются не позднее 10 (десяти) дней
                после предъявления выигрышного купона участника акции, в рабочее время
                в офисе ОсОО «ШНОС», по адресу: г. Бишкек, ул. Исанова 1/5.
              </p>
              <p className="finished-promotion-text">
                Выигрыши по основному розыгрышу выдаются в течение 3-х месяцев
                с момента проведения розыгрыша стимулирующей акции.
                По истечении установленного срока не востребованные призы
                признаются собственностью Организатора и не подлежат выдаче.
              </p>
            </div>
          </div>
        );
      } else {
        return (
          <div className="content-block">
            {details.imageFirst && (
              <img
                src={IMAGE_BASE_URL + details.imageFirst}
                alt="promotion"
                className="content-image"
              />
            )}
            {(details.promotionDetails || details.description) && (
              <p className="content-text">{details.promotionDetails || details.description}</p>
            )}
            {details.imageSecond && (
              <img
                src={IMAGE_BASE_URL + details.imageSecond}
                alt="promotion"
                className="content-image"
              />
            )}
          </div>
        );
      }
    }
  };

  return (
    <div className="details-page">
      <Header />
      <nav className="page-nav">
        <a href="/" className="nav-link">Главная</a>
        {details?.type === "news" ? (
          <>
            <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
            <a href="/about_company" className="nav-link">О компании</a>
            <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
            <a href="/about_company/news" className="nav-link">Новости</a>
            <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
            <span className="nav-link">{details?.title || ""}</span>
          </>
        ) : (
          <>
            <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
            <span className="nav-link">Подробности акции "{details?.title || ""}"</span>
          </>
        )}
      </nav>



      <div className="detail-promo">
        <div className="detail-promo-content">
          <div className="detail-text-block">
            {details?.date && (
              <span className="detail-date">{formatDate(details.date)}</span>
            )}
            {details?.title && <h2 className="detail-title">{details.title}</h2>}
            {details?.description && (
              <p className="detail-description">{details.description}</p>
            )}
          </div>
          <div className="detail-image-wrapper">
            <img
              src={src}
              alt=""
              aria-hidden="true"
              className="detail-image-bg"
            />
            <img
              src={src}
              alt="Detail promo"
              className="detail-image"
            />
          </div>
        </div>
      </div>

      <div className="details-page-content">{renderContent()}</div>
      <Footer />
    </div>
  );
};

export default DetailsPage;
